import { useRef, useState } from 'react'

import styles from './styles/EditorialNotices.css'
import OpenerIcon from './OpenerIcon'
import Fade from './Fade'
import useClickOut from '../../hooks/useClickOut'
import Link from './Link'

export const cleanStatus = (status) => {
  return status.split('_').join(' ').split('-').join(' ')
}

export const groupSimilarNotices = (notices) => notices?.reduce((acc, next) => {
  // If the notice is of status "new version" then only return it if the doi is different
  if (next.status.toLowerCase() === 'new version' && next.noticeDoi === next.doi) {
    return acc
  }

  // If the notice has no date but already exists in the status we don't need to show it again.
  if (!next?.date && acc.map(({ status }) => status).includes(next?.status)) {
    return acc
  }
  // If the notice has the same status and date, we don't need to show it again.
  if (acc.filter(({ status, date }) => next?.status === status && next?.date === date)?.length > 0) {
    return acc
  }
  return [...acc, next]
}, []) || []

const EditorialNotices = ({ paper }) => {
  const [show, setShow] = useState(false)
  const ref = useRef(null)

  useClickOut(ref, show, () => setShow(false))

  if (paper?.editorialNotices && groupSimilarNotices(paper?.editorialNotices).length === 0) {
    return null
  }
  return (
    <div ref={ref} className={styles.layout}>
      <span className={styles.header} onClick={() => setShow(!show)} role='button' tabIndex={0}><div>Editorial notices{' '}</div><OpenerIcon className={styles.icon} show={show} /></span>
      {show &&
        <ul className={styles.dropdown}>
          <Fade show={show}>
            {groupSimilarNotices(paper?.editorialNotices)?.map(({ doi, date, noticeDoi, status, urls }, i) => (
              <li key={i} className={styles.notice}>
                <a target='_blank' rel='noopener noreferrer' href={`https://doi.org/${noticeDoi || doi}`} className={styles.status}>
                  Notice: {cleanStatus(status)} {date && `(${date})`}
                </a>
                {urls?.length > 0 &&
                  <div className={styles.urls}>
                    See also:
                    <ul>
                      <li>{urls?.map((url, i) => <Link className={styles.urlLink} key={i} blue underline href={url}>{url}</Link>)}</li>
                    </ul>
                  </div>}
              </li>
            ))}
          </Fade>
        </ul>}
    </div>
  )
}

export default EditorialNotices
